import React from "react";
import { Button, Col, Layout, Row, Tooltip, Typography } from "antd";
import GreetingsTop from "../../../../components/menu/greetings-top";
import { LeftOutlined } from "@ant-design/icons";

import SupplierFilesList from "./list";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import CanShow from "../../../../components/can-show";

export default function Suppliers() {
  const { Title } = Typography;
  const navigate = useNavigate();
  let { id } = useParams();

  return (
    <Layout>
      <GreetingsTop />
      <div className="catalog__container">
        <Row className="header-top">
          <Col xs={19} className="header-top__left">
            <Title
              level={3}
              style={{ top: 0, bottom: 0, height: "78%", margin: "auto" }}
            >
              {`Archivos del proveedor ${id}`}
            </Title>
          </Col>
          <Col xs={5}>
            <Row style={{ marginBottom: 30, justifyContent: "right" }}>
              <Tooltip title="Atrás">
                <CanShow roles={["Supplier"]}>
                  <Button
                    style={{ color: "gray", fontSize: 20, height: 0, width: 0 }}
                    type="link"
                    icon={<LeftOutlined />}
                    onClick={() => navigate("/")}
                  />
                </CanShow>
                <CanShow roles={["Admin", "Financial Advisor", "Customer"]}>
                  <Button
                    style={{ color: "gray", fontSize: 20, height: 0, width: 0 }}
                    type="link"
                    icon={<LeftOutlined />}
                    onClick={() => navigate("/suppliers")}
                  />
                </CanShow>
              </Tooltip>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="catalog__container">
        <SupplierFilesList />
      </div>
    </Layout>
  );
}
